import { createFileRoute } from "@tanstack/react-router";
import SaintVibe from "@/pages/SaintVibe";
export const Route = createFileRoute("/saint-vibe")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® Vibe Assessment | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SAINT® Vibe assessment at Neuro Wellness in Coral Springs, FL. Take our free vibe screener to see if accelerated TMS may be right for your depression.",
        },
        {
          property: "og:title",
          content: "SAINT® Vibe Assessment | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SAINT® Vibe assessment at Neuro Wellness in Coral Springs, FL. Take our free vibe screener to see if accelerated TMS may be right for your depression.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-vibe",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-vibe",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintVibe />;
}
